import { useState } from 'react';

import { z } from 'zod';

import { requestUnlock as apiRequestUnlock } from '../services/unlockService';
import useAuthForm from './useAuthForm';

const DEFAULT_VALUES = {
  email: '',
};

const formSchema = z.object({
  email: z.string().email('Invalid email address.'),
});

const useRequestUnlockForm = () => {
  const [submissionSuccessful, setSubmissionSuccessful] = useState(false);

  const handleSubmit = async (formData, { form }) => {
    setSubmissionSuccessful(false);

    await apiRequestUnlock(formData.email);

    setSubmissionSuccessful(true);
    form.reset();
  };

  const authForm = useAuthForm({
    defaultValues: DEFAULT_VALUES,
    onSubmit: handleSubmit,
    schema: formSchema,
  });

  return { ...authForm, submissionSuccessful };
};

export default useRequestUnlockForm;
